import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './routes/ProtectedRoute';
import PublicRoute from './routes/PublicRoute';
import RoleRoute from './routes/RoleRoute';
import SessionWatcher from './components/SessionWatcher';
import WizardGate from './pages/apply/WizardGate';
import { routes, DEFAULT_PUBLIC_ROUTE, USER_TYPES } from './routes/routeConfig';

import PersonalInfoStep from './pages/apply/personal';
import KycStep from './pages/apply/kyc';
import LoanStep from './pages/apply/loan';
import DocumentsStep from './pages/apply/documents';
import ReviewStep from './pages/apply/review';
import StatusStep from './pages/apply/status';

import UnderwriterLayout from './layouts/underwriterLayout';
import QueuePage from './pages/review/queue';
import ReviewPage from './pages/review/detail';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <SessionWatcher />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
        limit={3}
      />
      <Routes>
        {routes.map(({ path, element: Element, protected: isProtected, allowedUserTypes }) => {
          let page = <Element />;

          if (allowedUserTypes) {
            page = <RoleRoute allowedUserTypes={allowedUserTypes}>{page}</RoleRoute>;
          }
          if (isProtected === true) {
            page = <ProtectedRoute>{page}</ProtectedRoute>;
          } else if (isProtected === false) {
            page = <PublicRoute>{page}</PublicRoute>;
          }

          return <Route key={path} path={path} element={page} />;
        })}

        {/* Applicant wizard: gate + layout, six child steps */}
        <Route
          path="/apply"
          element={
            <ProtectedRoute>
              <RoleRoute allowedUserTypes={[USER_TYPES.APPLICANT]}>
                <WizardGate />
              </RoleRoute>
            </ProtectedRoute>
          }>
          <Route index element={<Navigate to="/apply/personal" replace />} />
          <Route path="personal" element={<PersonalInfoStep />} />
          <Route path="kyc" element={<KycStep />} />
          <Route path="loan" element={<LoanStep />} />
          <Route path="documents" element={<DocumentsStep />} />
          <Route path="review" element={<ReviewStep />} />
          <Route path="status" element={<StatusStep />} />
        </Route>

        {/* Underwriter: queue + application detail */}
        <Route
          path="/review"
          element={
            <ProtectedRoute>
              <RoleRoute allowedUserTypes={[USER_TYPES.INTERNAL]}>
                <UnderwriterLayout />
              </RoleRoute>
            </ProtectedRoute>
          }>
          <Route index element={<QueuePage />} />
          <Route path=":id" element={<ReviewPage />} />
        </Route>

        <Route path="/" element={<Navigate to={DEFAULT_PUBLIC_ROUTE} replace />} />
        <Route path="*" element={<Navigate to={DEFAULT_PUBLIC_ROUTE} replace />} />
      </Routes>
    </>
  );
}

export default App;
